// extracted by mini-css-extract-plugin
export default {"image":"cX-z","loaded":"dX-z"};